export const displayTypeEnum = {
  MOBILE: 'MOBILE',
  // WEB: 'WEB',
}

export const displayTypeText = {
  [displayTypeEnum.MOBILE]: 'Mobile app',
  // [displayTypeEnum.WEB]: 'Website',
}

export const displayTypeDetailText = {
  [displayTypeEnum.MOBILE]: 'Mobile Application',
  // [displayTypeEnum.WEB]: 'Website',
}

export const statusEnum = {
  NEW: 'New',
  BOOKED: 'Booked',
  RESCHEDULE: 'Reschedule',
  DONE: 'Done',
  CANCELLED: 'Cancelled',
}

export const statusTextOption = {
  [statusEnum.NEW]: 'New',
  [statusEnum.DONE]: 'Done',
  // [statusEnum.RESCHEDULE]: 'Reschedule',
  // [statusEnum.CANCELLED]: 'Cancelled',
}

export const forPackageEnum = {
  YES: 1,
  NO: 0,
}

export const forPackageText = {
  [forPackageEnum.YES]: 'Yes',
  [forPackageEnum.NO]: 'No',
}

export const genderEnum = {
  FEMALE: 'F',
  MALE: 'M',
}

export const genderText = {
  [genderEnum.FEMALE]: 'Female',
  [genderEnum.MALE]: 'Male',
}

export const prefixEnum = {
  MR: 'mr',
  MISS: 'miss',
  MRS: 'mrs',
  BOY: 'boy',
  GIRL: 'girl',
}

export const prefixText = {
  [prefixEnum.MR]: 'Mr.',
  [prefixEnum.MISS]: 'Miss',
  [prefixEnum.MRS]: 'Mrs.',
  [prefixEnum.BOY]: 'Boy',
  [prefixEnum.GIRL]: 'Girl'
}